//components/success/SuccessPage.jsx




import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SuccessPageStyles from './SuccessPage.styles'; 
const SuccessPage = () => {
  const navigate = useNavigate();

  // Navigate back to the dashboard
  const handleGoBack = () => {
    navigate('/agent-dashboard'); // Adjust the path based on your routing setup
  };

  return (
    <Box sx={SuccessPageStyles.container}>
      <Box sx={SuccessPageStyles.content}>
        <Typography variant="h2" sx={SuccessPageStyles.successMessage}>
          Success! 🎉
        </Typography>
        <Typography variant="h5" sx={SuccessPageStyles.subMessage}>
          The locks have been successfully added to your account.
        </Typography>
        <Button variant="contained" sx={SuccessPageStyles.button} onClick={handleGoBack}>
          Go Back to Dashboard
        </Button>
      </Box>
    </Box>
  );
};

export default SuccessPage;
